import { z } from 'zod';
import { useTranslatedUserSchemaParts } from 'hooks/zod/useTranslatedUserSchemaParts';

export function useCreateSelfRegisterCustomerSchema() {
    const {
        first_name,
        last_name,
        optional_address,
        postal_code,
        co,
        optional_city,
        email,
        date_of_birth,
        mobile,
        password,
        terms_and_conditions,
    } = useTranslatedUserSchemaParts();

    return z.object({
        // General
        first_name,
        last_name,
        date_of_birth,

        // Contact
        email,
        mobile,

        // Address
        co,
        postal_code,
        address: optional_address,
        city: optional_city,

        password,
        password_again: password,

        // Tags
        class_interest: z.boolean(),
        career_interest: z.boolean(),

        // More Consent
        newsletter: z.boolean(),
        communication_consultant: z.boolean(),

        user_agreement: terms_and_conditions,
    });
}

export type SelfRegisterCreateCustomerSchemaType = z.infer<ReturnType<typeof useCreateSelfRegisterCustomerSchema>>;
